"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_dom_1 = require("react-dom");
const hooks_1 = require("./hooks");
const react_router_1 = require("react-router");
const routes_1 = require("./routes");
const preloader_1 = require("./preloader");
exports.chykHydrateOrRender = (chyk) => {
    if (!chyk.el) {
        throw "No renderer for no element";
    }
    const renderer = chyk.el.childNodes.length === 0 ? react_dom_1.render : react_dom_1.hydrate;
    renderer(react_1.default.createElement(exports.ChykComponent, { chyk: chyk }), chyk.el);
};
exports.ChykComponent = ({ chyk }) => {
    if (!chyk.history) {
        throw "No history";
    }
    const WrapperComponent = chyk.component || react_1.default.Fragment;
    return (react_1.default.createElement(hooks_1.ChykContext.Provider, { value: chyk },
        react_1.default.createElement(react_router_1.Router, { history: chyk.history },
            react_1.default.createElement(preloader_1.ChykPreloader, null,
                react_1.default.createElement(WrapperComponent, null,
                    react_1.default.createElement(routes_1.DataRoutes, { routes: chyk.routes }))))));
};
exports.ChykComponent.displayName = "ChykComponent";
exports.ChykStaticComponent = ({ chyk }) => {
    const WrapperComponent = chyk.component || react_1.default.Fragment;
    return (react_1.default.createElement(hooks_1.ChykContext.Provider, { value: chyk },
        react_1.default.createElement(react_router_1.StaticRouter, { location: chyk.locationState.location, context: chyk.staticRouterContext },
            react_1.default.createElement(WrapperComponent, null,
                react_1.default.createElement(routes_1.DataRoutes, { routes: chyk.routes })))));
};
exports.ChykStaticComponent.displayName = "ChykStaticComponent";
//# sourceMappingURL=render.js.map